module.exports = __webpack_public_path__ + "img/logo.7652f6f4.jpg";